var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Information_accent_notification",
    "data-name": "Information, accent notification",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9024",
    "data-name": "Rectangle 9024",
    width: 16.207,
    height: 16.207,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3045",
    "data-name": "Ellipse 3045",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4972f4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Information",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6752",
    "data-name": "Mask Group 6752",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38818",
    "data-name": "Group 38818",
    transform: "translate(6.785 1.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35592",
    "data-name": "Path 35592",
    d: "M8.453,5.7a1.253,1.253,0,0,1-.914-.374,1.239,1.239,0,0,1-.379-.916,1.264,1.264,0,0,1,.388-.916,1.232,1.232,0,0,1,.9-.393,1.253,1.253,0,0,1,.923.393,1.264,1.264,0,0,1,.388.916,1.239,1.239,0,0,1-.379.916A1.275,1.275,0,0,1,8.453,5.7ZM9.5,7.6v9.371H7.419V7.6Z",
    transform: "translate(-7.16 -3.096)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ad7f2e8bd6705f24c8e5889aa02e9b9b.svg";
export { ForwardRef as ReactComponent };